<template>
  <router-link
    :to="{
      name: 'topic_detail',
      query: {
        id: item.article_id,
      },
    }"
    target="_blank"
    class="dafu-item"
  >
    <div class="title" :title="item.title">{{ item.title }}</div>
    <div class="subtitle">
      <span class="time"> {{ item.addtime | dayjs("year-date") }}</span>
      <span class="source">{{ item.resource }}</span>
    </div>
    <span class="more">查看</span>
  </router-link>
</template>

<script>
export default {
  name: "Item",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.dafu-item {
  background-color: #f5f5f5;
  display: block;
  padding: 20px 20px 0;
  height: 89px;
  position: relative;
  margin-bottom: 20px;

  .title {
    width: 724px;
    font-size: 18px;
    font-size: var(--font-size-18);
    font-weight: 500;
    line-height: 25px;
    color: #303133;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .subtitle {
    margin-top: 4px;
    .time {
      height: 20px;
      font-size: 14px;
      font-size: var(--font-size-14);
      font-weight: 500;
      line-height: 20px;
      color: #c0c4cc;
    }
    .source {
      font-size: 14px;
      font-size: var(--font-size-14);
      font-weight: 500;
      line-height: 20px;
      color: #c0c4cc;
    }
  }
  .more {
    font-size: 16px;
    font-size: var(--font-size-16);
    font-weight: 500;
    line-height: 22px;
    color: #0d7ce4;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -11px;
  }
  &:hover,
  &.active {
    background: rgba(242, 246, 252, 0.39);
    .title {
      color: #0d7ce4;
    }
    .source,
    .time {
      color: #8dc7ff;
    }
  }
}
</style>
